export default __webpack_public_path__ + "static/media/Emojis06.34eae2ec.png";